import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { ISiteNameWithId } from '../../../siteManagement/serverApi/types/ISiteNameWithId';
import { INamedItem, IPublishedConnectionWithTablesItem } from '../../../spacesPlatform/models/resourceParts';
import { IExtractServiceTask, IExtractTask } from '../types/IExtractTask';

export interface IGetExtractTasksResult extends IGetItemsResult {
  tasks: IExtractTask[];
  datasources?: INamedItem[];
  workbooks?: INamedItem[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  publishedConnections?: IPublishedConnectionWithTablesItem[];
  extractServiceTasks?: IExtractServiceTask[];
}

export class GetExtractTasksRequest extends Request<IGetItemsParams, IGetExtractTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getExtractTasks', params);
  }
}
